import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  BaseUrl,
  GetPhonePayPaymentLink,

} from "../../BaseUrl/BaseUrl";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import Select from "react-select";
import { ERROR_MESSAGES } from "../GlobalErrorMessage";
import CODPaymentModal from "../Payment Gateway/CODPaymentModal";
import fav from "../../assets/images/new/fav-removebg-preview.png";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { AddUpdateProductBooking, AddUpdateRemoveCart, GetDeliveryCharges, GetProductCartList } from "../../ApiServices/EStore/EStoreApi";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Nav, Tab } from "react-bootstrap";
import {
  Prasad_Cart,
  Prasad_CartList,
  Prasad_Order,
} from "../../ApiServices/Prasad/PrasadApi";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { customSelectStyles } from "../../middlewares/Utils";
import { handleProceedRemainingPayment } from "../RazorPay/RazorPayFunction";
import { FaqModuleID, pujaServiceID, pujaSubServiceID } from "../enum";
import { GetUserWalletAmount } from "../../ApiServices/UserWallet/UserWalletApi";
import CouponModal from "../CouponModal";
import NoResultFoundModel from "../NoDataFound/NoDataFoundModal";
import { t } from "i18next";
import useApplyCouponCode from "../SingleCoupon";

const ViewCart = () => {

  const navigate = useNavigate();
  const userKeyID = localStorage.getItem("userKeyID")
  const [qty, setQty] = useState();
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;
  const [couponCodeInput, setCouponCodeInput] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [couponMessageVisible, setCouponMessageVisible] = useState(false);
  const [product, setProduct] = useState([]);
  const [prasadList, setPrasadList] = useState([]);
  const [total, setTotal] = useState(0);
  const [showProductDetails, setShowProductDetails] = useState(true);
  const [showProductTabDetails, setShowProductTabDetails] = useState(true);
  const [discount, setDiscount] = useState(0);
  const location = useLocation();
  const [showCodModal, setShowCodModal] = useState(false);
  const [error, setError] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [qqty, setQqty] = useState(0);
  const [shipCharges, setShippingCharges] = useState(0);
  const [deliveryChargesAmt, setDeliveryChargesAmt] = useState(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
  const [isBothVisible, setIsBothVisible] = useState(false);
  const [isProductCart, setIsProductCart] = useState(false);
  const [isPrasadCart, setIsPrasadCart] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAddressDetails, setShowAddressDetails] = useState(false);
  const [productID, setProductID] = useState([]);

  const [activeTab, setActiveTab] = useState(
    showProductDetails === null
      ? "address"
      : showAddressDetails
        ? "products"
        : !showAddressDetails
          ? "prasad"
          : ""
  );
  const [shipAdd, setShipAdd] = useState({
    PinCode: "",
    Flat: "",
    Colony: "",
    Landmark: "",
    City: "",
    State: "",
    Payment: "",
    countryID: null,
    districtID: "",
    stateID: "",
  });
  const {
    setLoader,
    loader,
    isLocationUpdate,
    setIsLocationUpdate,
    setIsCartUpdate,
    isCartUpdate,
  } = useContext(LoaderContext);
  const ProductCount = localStorage.getItem("cartItemCount");
  const prasadCount = localStorage.getItem("PrasadcartCount");
  const [isTabChange, setIsTabChange] = useState(false);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const [loginPopUp, setLoginPopUp] = useState(null);
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    CodPayload: null,
    totalVal: null,
    productName: null,
    productPrice: null,
    productID: null,
    moduleName: null,
    couponCode: null
  });
  const [showModal, setShowModal] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState({
    CouponCode: null,
    isApplied: false,
    CoupenAmount: 0,
    walletAmount: 0,
    couponCodeID: null
  });
  const userID = localStorage.getItem("userID");
  const [couponAmount, setCouponAmount] = useState(0)
  const [walletAmount, setWalletAmount] = useState(0)


  const [isCouponApplied, setIsCouponApplied] = useState(false);

  const [isWalletApplied, setIsWalletApplied] = useState(false);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  const [couponObj, setCouponObj] = useState({
    userKeyID: userKeyID,
    pujaServiceID: pujaServiceID?.Ecommerce,
    pujaSubServiceID: isPrasadCart ? pujaSubServiceID?.Prasad : pujaSubServiceID?.Product,
    subModuleID: productID,
    orderAmount: 0
  })
  const {
    applyCoupon,
    isApplying,
  } = useApplyCouponCode({
    apiParam: couponObj,
    setIsCouponApplied,
    setAppliedCoupon,
    setIsWalletApplied,
  });
  const [productTotalRecords, setProductTotalRecords] = useState(-1)
  const [prasadTotalRecords, setPrasadTotalRecords] = useState(-1)

  const ValidationToast = () =>
    toast.error("Please fill all fields before proceeding with the payment.");

  useEffect(() => {
    GetUserWalletAmountData()
    getProducts();
    fetchCountryList();
  }, []);

  useEffect(() => {
    if (isAddUpdateDone) {
      getProducts();
      setIsAddUpdateDone(false)
    }
  }, [isAddUpdateDone])

  useEffect(() => {

    if (isWalletApplied && appliedCoupon?.isApplied === false) {
      const minAmount = Math.min(total, walletAmount);
      const discountAmount = Math.round(minAmount * 0.5);
      setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
      setCouponAmount(discountAmount);
      // setCouponAmount(walletAmount)
    } else if (isWalletApplied === false && appliedCoupon?.isApplied === true) {
      setCouponAmount(appliedCoupon?.CoupenAmount)
    } else {
      setCouponAmount(0)
    }
  }, [isWalletApplied, appliedCoupon])





  useEffect(() => {

    if (isTabChange) {

      if (prasadList?.length > 0) {
        const calculatedTotal = prasadList?.reduce(
          (total, item) => total + item.discountedAmount * item.quantity,
          0
        );
        const calculatedTotalDiscount = prasadList?.reduce(
          (total, item) =>
            total + Math.round((item?.discountedAmount) * item.quantity),
          0
        );
        setTotal(calculatedTotal);
        setCouponObj((prev) => ({ ...prev, orderAmount: calculatedTotal, pujaSubServiceID: pujaSubServiceID.Prasad }))
        setDiscount(calculatedTotalDiscount);

      }
    } else {
      if (product?.length > 0) {
        const calculatedTotal = product?.reduce(
          (total, item) => total + ((item?.discountedAmount) * item.quantity),
          0
        );
        const calculatedTotalDiscount = product?.reduce(
          (total, item) =>
            total + Math.round((item?.discountedAmount)),
          0
        );
        setTotal(calculatedTotal);
        setCouponObj((prev) => ({ ...prev, orderAmount: calculatedTotal }))
        setDiscount(calculatedTotalDiscount);
      } else if (prasadList?.length > 0) {
        const calculatedTotal = prasadList?.reduce(
          (total, item) => total + item.discountedAmount * item.quantity,
          0
        );
        const calculatedTotalDiscount = prasadList?.reduce(
          (total, item) =>
            total + Math.round((item?.discountedAmount) * item.quantity),
          0
        );
        setTotal(calculatedTotal);
        setCouponObj((prev) => ({ ...prev, orderAmount: calculatedTotal, pujaSubServiceID: pujaSubServiceID?.Product }))
        setDiscount(calculatedTotalDiscount);
      }
    }
    calculateTotals();
  }, [product, prasadList, isTabChange]);



  useEffect(() => {
    fetchStateList(selectedCountry);
  }, [selectedCountry]);
  useEffect(() => {
    fetchDistrictList(selectedState);
  }, [selectedState]);
  useEffect(() => {
    setModelRequestData((PREV) => ({
      ...PREV,
      totalVal: PREV.totalVal + deliveryChargesAmt,
    }));
  }, [shipCharges]);

  useEffect(() => {
    if (countryList.length > 0) {
      const firstCountry = countryList[0];
      setSelectedCountry(firstCountry.value);
      setShipAdd((prev) => ({
        ...prev,
        Country: firstCountry.label, // Store Country Name
        countryID: firstCountry.value, // Store Country ID
      }));
      fetchStateList(firstCountry.value); // Fetch states for the first country
    }
  }, [countryList]); // Runs when countryList is updated


  // useEffect(() => {
  //   if (total !== null && total !== undefined && total !== 0 && totalDiscountAmount !== null && totalDiscountAmount !== undefined && totalDiscountAmount !== 0) {
  //     setCouponObj((prev) => ({ ...prev, orderAmount: total - totalDiscountAmount }));
  //   } else {
  //     setCouponObj((prev) => ({ ...prev, orderAmount: 0 }));
  //   }
  // }, [total, totalDiscountAmount])

  const GetUserWalletAmountData = async () => {

    setLoader(true);
    try {
      let response = await GetUserWalletAmount(userKeyID); // Replace with actual import/function call
      if (response?.statusCode === 200) {
        setLoader(false);

        const list = response?.responseData?.data
        setWalletAmount(Number(list) <= 0 ? 0 : list)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleOpenCoupenModal = () => {

    setModelRequestData((prev) => ({ ...prev, moduleName: 'e-store' }))
    setShowModal(true)
  }


  const fetchCountryList = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/Country`);


      // Check the response code correctly
      if (response.data.ResponseCode === "0") {
        const countries = response.data.DATA || []; // Access DATA array
        const formattedCountryList = countries.map((country) => ({
          value: country.COUNTRY_ID,
          label: country.COUNTRY_NAME,
        }));
        setCountryList(formattedCountryList);
      } else {
        console.error(
          "Error fetching countries:",
          response.data.ResponseMessage
        );
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  const fetchStateList = async (countryID) => {
    if (!countryID) {
      return;
    }
    try {
      const response = await axios.get(
        `${BaseUrl}/State?CountryID=${countryID}`
      );


      // Check the response code correctly
      if (response.data.ResponseCode === "0") {
        const states = response.data.DATA || []; // Access DATA array
        const formattedStateList = states.map((state) => ({
          value: state.StateID,
          label: state.StateName,
        }));
        setStateList(formattedStateList);
      } else {
        console.error("Error fetching states:", response.data.ResponseMessage);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };
  useEffect(() => {
    GetDeliveryChargesLookupListData();
  }, [shipAdd]);



  const GetDeliveryChargesLookupListData = async () => {

    if (!shipAdd.districtID) {
      return;
    }
    try {
      const response = await GetDeliveryCharges(
        shipAdd.stateID,
        shipAdd.districtID
      ); // Ensure this function is imported correctly
      if (response?.ResponseCode === "0") {
        const CalculatedShippingCharges = response?.DATA[0].DeliveryCharges;
        setDeliveryChargesAmt(CalculatedShippingCharges);
        setModelRequestData((PREV) => ({
          ...PREV,
          totalVal: PREV.totalVal + CalculatedShippingCharges,
        }));
      } else {
        console.error(
          "Failed to fetch sim Type lookup list:",
          response?.data?.statusMessage || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error fetching sim Type lookup list:", error);
    }
  };

  const fetchDistrictList = async (stateID) => {
    if (!stateID) {
      return;
    }
    try {
      const response = await axios.get(`${BaseUrl}/City?StateID=${stateID}`);


      // Check the response code correctly
      if (response.data.ResponseCode === "0") {
        const districts = response.data.DATA || []; // Access DATA array
        const formattedDistrictList = districts.map((district) => ({
          value: district.DistrictID, // Use DistrictID as the identifier
          label: district.DistrictName, // Use DistrictName as the label
        }));
        setCityList(formattedDistrictList); // Update state with the list of districts
      } else {
        console.error(
          "Error fetching districts:",
          response.data.ResponseMessage
        );
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };


  const getProducts = async () => {

    setLoader(true);
    try {
      const response = await GetProductCartList("Product", userKeyID);

      if (response?.statusCode === 200) {
        const data = response?.responseData?.data
        setLoader(false);

        const updatedProducts = data?.productList?.map((item) => ({
          ...item,
          price: item.productPrice, // if 'price' exists, use it
        }));
        const updatedPrasadList = data?.prasadList?.map((item) => ({
          ...item,
          price: item.productPrice, // if 'price' exists, use it
        }));

        setIsProductCart(data?.productCount > 0)
        setIsPrasadCart(data?.prasadCount > 0)
        setProduct(updatedProducts);
        setPrasadList(updatedPrasadList)

        setProductTotalRecords(data?.productCount + data?.prasadCount)



      }

    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };




  const deleteProduct = (product) => {
    const toastId = "delete-confirmation"; // fixed ID

    toast(
      (t) => (
        <div>
          <span>Are you sure you want to delete this product?</span>
          <div style={{ marginTop: "10px" }}>

            <button
              className="Normal-app-btn"
              style={{ padding: "5px 16px", fontSize: "14px", backgroundColor: "white", color: "black" }}
              onClick={() => toast.dismiss(toastId)}
            >
              No
            </button>
            <button
              className="Normal-subcribe-btn mx-2"
              onClick={() => {
                toast.dismiss(toastId);
                proceedWithDeletion(product);
              }}
            >
              Yes
            </button>
          </div>
        </div>
      ),
      { id: toastId } // <--- this ensures no duplicates
    );
  };

  const proceedWithDeletion = async (product) => {
    try {
      const response = await AddUpdateRemoveCart({
        cartKeyID: product?.cartKeyID,
        productKeyID: product?.productKeyID,
        userKeyID: userKeyID,
        action: "Delete"
      });

      if (response?.statusCode === 200) {
        setIsAddUpdateDone(true)
        setIsCartUpdate(true)
      } else {
        setLoader(false);

      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }

  };



  const calculateTotals = () => {
    const totalDiscountPercentApi = product?.length > 0 ? product?.reduce(
      (acc, item) => acc + Number(item.discount || 0),
      0
    ) : prasadList?.reduce(
      (acc, item) => acc + Number(item.discount || 0),
      0
    );
    const totalDiscountRupeeApi = product?.length > 0 ? Math.round(
      product?.reduce((acc, item) => {
        return acc + Number(item.DiscountAmount || 0);
      }, 0)
    ) : prasadList?.reduce((acc, item) => {
      return acc + Number(item.DiscountAmount || 0);
    }, 0)
    const totalProductPriceWithOutDiscountApi = product?.length > 0 ? product?.reduce(
      (acc, item) => acc + Number(item.productPrice || 0),
      0
    ) : prasadList?.reduce(
      (acc, item) => acc + Number(item.productPrice || 0),
      0
    )
    const totalProductAfterDiscount = Math.round(
      totalProductPriceWithOutDiscountApi - totalDiscountRupeeApi
    );

    const taxAmount = Math.round((totalProductAfterDiscount * 5) / 100); // 5% tax (rounded)
    const finalTotalWithTax = Math.round(totalProductAfterDiscount + taxAmount); // Final total (rounded)
    // const finalTotalWithShippingCharge = Math.round(finalTotalWithTax + deliveryCharges);
    // Final total (rounded)

    setTotalDiscountAmount(totalDiscountRupeeApi);
  };
  const AddQuantity = async (product) => {
    try {
      const response = await AddUpdateRemoveCart({
        cartKeyID: product?.cartKeyID,
        productKeyID: product?.productKeyID,
        userKeyID: userKeyID,
        action: "Add"
      });

      if (response?.statusCode === 200) {
        setIsAddUpdateDone(true)

      } else {
        setLoader(false);

      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const removeQuantity = async (product) => {
    try {
      const response = await AddUpdateRemoveCart({
        cartKeyID: product?.cartKeyID,
        productKeyID: product?.productKeyID,
        userKeyID: userKeyID,
        action: "Update"
      });

      if (response?.statusCode === 200) {
        setIsAddUpdateDone(true)
        setIsCartUpdate(true)
      } else {
        setLoader(false);

      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }

  };

  const PaymentApproved = async (paymentMode) => {

    const { PinCode, Flat, Colony, Landmark, City, State, Payment } = shipAdd;

    let productKeyID = "";
    let price = "";
    let discount = "";
    let quantity = "";
    if (isTabChange) {
      product.forEach((products) => {
        productKeyID = productKeyID.concat(",", products.productKeyID);
        price = price.concat(",", products.price);
        discount = discount.concat(",", products.discount);
        quantity = quantity.concat(",", products.quantity);
      });
    } else {
      product.forEach((products) => {
        productKeyID = productKeyID.concat(",", products.productKeyID);
        price = price.concat(",", products.productPrice);
        discount = discount.concat(",", products.discount);
        quantity = quantity.concat(",", products.quantity);
      });
    }

    const Prod_Id1 = productKeyID.slice(1);
    setProductID(Prod_Id1)




    const ToTalAmount =
      parseFloat(total) + parseFloat(deliveryChargesAmt) - discount;
    let finalPayment =
      paymentMode === "online"
        ? ToTalAmount.toFixed(2)
        : (ToTalAmount * 0.2).toFixed(2);
    let remainingAmount =
      paymentMode === "online"
        ? "0.00"
        : (ToTalAmount - finalPayment).toFixed(2);

    if (
      shipAdd.City &&
      shipAdd.PinCode &&
      shipAdd.Flat &&
      shipAdd.Colony &&
      shipAdd.Landmark &&
      shipAdd.State
    ) {

      const PlaceOrderResponse = await handleProceedRemainingPayment(Math.round(grandTotal))

      if (PlaceOrderResponse?.status === 1) {

        const PAYLOAD = {
          userKeyID: userKeyID,
          orderAddress: ` ${Flat} ${Colony} ${Landmark} ${City} ${State} ${Payment}-${PinCode}`,
          deliveryCharges: `${deliveryChargesAmt}`,
          transactionAmount: grandTotal,
          transactionID: PlaceOrderResponse?.razorpay_payment_id,
          shippingCharges: deliveryChargesAmt,
          paymentTypeID: paymentMode === "online" ? 2 : 1,
          couponCodeID: appliedCoupon?.couponCodeID,
          couponCodeAmount: appliedCoupon?.CoupenAmount,
          walletAmount: appliedCoupon?.walletAmount,
          paymentStatus: true,
          applicationType: "Website",
          productType: (isPrasadCart && !isProductCart) || isTabChange ? "Prasad" : "Product",

        };
        AddUpdateProductBookingData(PAYLOAD)

      } else if (PlaceOrderResponse?.status === 0) {
        setLoader(false)
        alert('Order Failed !')
      }
    } else {
      ValidationToast();

    }
  };

  const AddUpdateProductBookingData = async (apiParam) => {

    setLoader(true);
    try {
      const response = await AddUpdateProductBooking(apiParam);

      if (response?.statusCode === 200) {
        const data = response?.responseData?.data
        setLoader(false);
        setIsCartUpdate(true)
        setIsAddUpdateDone(true)
        navigate("/thank-you", {
          state: { moduleName: (isPrasadCart && !isProductCart) || isTabChange ? "PrasadBooking" : "MyStore" },
        });

      } else {
        setLoader(false);

      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };


  const grandTotal = Math.round(
    // (((total - totalDiscountAmount) * 1.05).toFixed(0) - couponAmount) + Number(deliveryChargesAmt) // tax disabled
    ((total - totalDiscountAmount) - couponAmount) + Number(deliveryChargesAmt)
  );
  const DiscountAmountForApi = Math.round(totalDiscountAmount);
  const RealTotalPriceAmt = Math.round(total);
  const SubTotalVal = Math.round(total - totalDiscountAmount);
  const TaxAmtVal = Math.round((total - totalDiscountAmount) * 0.05);



  const allFieldsFilled =
    shipAdd.City &&
    shipAdd.Flat &&
    shipAdd.Colony &&
    shipAdd.Landmark &&
    shipAdd.PinCode &&
    shipAdd.State;
  const PrasadCart = () => {
    return (
      <>
        <div className="container mt-4 ">
          {prasadList?.length > 0 && (
            <>
              <div className="row w-100">
                {/* Left Section - Cart Items */}
                <div className="col-md-8">
                  {showProductDetails ? (
                    // Product Details UI
                    <>
                      <h5>{t("Prasad Details")}</h5>
                      {prasadList?.map((item) => (
                        <div
                          key={item.id}
                          className="card mb-3 p-3 shadow-sm position-relative"
                        >
                          {/* Remove button */}
                          <button
                            className="btn btn-sm btn-outline-secondary position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={() => deleteProduct(item)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>

                          <div className="row g-3 align-items-center">
                            {/* Product Image */}
                            <div className="col-3">
                              <img
                                src={item.productImageURL || fav}
                                alt="Prasad image"
                                className="img-fluid rounded"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            {/* Product Details */}
                            <div className="col-9">
                              <h5 className="mb-1">{item.productName}</h5>
                              <h6 style={{ color: "#A42642" }}>
                                ₹{" "}
                                {Number(
                                  item.discountedAmount
                                )}
                                {Number(item.discount) > 0 && (
                                  <>
                                    <span
                                      className="text-muted ms-2"
                                      style={{
                                        textDecoration: "line-through",
                                        fontSize: "14px",
                                      }}
                                    >
                                      ₹{" "}
                                      {item.price *
                                        Number(item?.quantity)}
                                    </span>
                                    <p>
                                      <span
                                        style={{ background: "#8f3246" }}
                                        className="badge"
                                      >
                                        {t("Discount")} {item.discount}%
                                      </span>
                                    </p>
                                  </>
                                )}
                              </h6>

                              {/* Quantity Controls */}
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => removeQuantity(item)}
                                >
                                  -
                                </button>
                                <span>{item.quantity}</span>
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => AddQuantity(item)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    // Address Input UI
                    <>
                      <div class="mb-3 ">
                        <Select
                          styles={customSelectStyles}
                          name="Country"
                          placeholder={t("Select Country")}
                          options={countryList}
                          value={
                            countryList.find(
                              (country) => country.value === shipAdd?.countryID
                            ) || null
                          } // Ensure correct list
                          onChange={(e) => {
                            const selectedCountry = countryList.find(
                              (country) => country.value === e.value
                            );

                            if (selectedCountry) {
                              setShipAdd((prev) => ({
                                ...prev,
                                Country: selectedCountry.label, // Store Country Name
                                countryID: selectedCountry.value, // Store Country ID
                              }));
                            }

                            setSelectedCountry(e.value);
                            setStateList([]); // Reset state when country changes
                            setCityList([]); // Reset city when country changes
                            fetchStateList(e.value); // Fetch new state list based on country
                          }}
                        />
                      </div>
                      <div class="mb-3 ">
                        <Select
                          styles={customSelectStyles}
                          name="State"
                          placeholder="Select State"
                          options={stateList}
                          value={
                            stateList.find(
                              (state) => state.value === shipAdd?.stateID
                            ) || null
                          }
                          onChange={(e) => {
                            setSelectedState(e.value);
                            const selectedState = stateList.find(
                              (state) => state.value === e.value
                            );

                            if (selectedState) {
                              setShipAdd((prev) => ({
                                ...prev,
                                State: selectedState.label,
                                stateID: selectedState.value, // Store StateID
                              }));
                            }
                          }}
                        />
                      </div>
                      <div class="mb-3 ">
                        <Select
                          styles={customSelectStyles}
                          name="City"
                          placeholder="Select City"
                          options={cityList}
                          value={
                            cityList.find(
                              (city) => city.value === shipAdd?.districtID
                            ) || null
                          } // Fix here
                          onChange={(e) => {
                            const selectedCity = cityList.find(
                              (city) => city.value === e.value
                            );

                            if (selectedCity) {
                              setShipAdd((prev) => ({
                                ...prev,
                                City: selectedCity.label,
                                districtID: selectedCity.value, // Store DistrictID
                              }));
                            }
                          }}
                        />
                      </div>

                      <div class="mb-3 ">
                        <input
                          type="text"
                          placeholder=" Pincode"
                          className="custom-form-control"
                          id="pincode"
                          value={shipAdd?.PinCode || ""}
                          maxLength={6}
                          onChange={(e) => {
                            // Remove non-alphabet characters except spaces
                            const formattedInput = e.target.value
                              .replace(/[^\d]/g, "")
                              .trim();

                            setShipAdd((prev) => ({
                              ...prev,
                              PinCode: formattedInput, // Update Flat instead of name
                            }));
                          }}
                        />
                        {error &&
                          (shipAdd?.PinCode === "" ||
                            shipAdd?.PinCode === null ||
                            shipAdd?.PinCode === undefined) ? (
                          <span
                            className="text-danger"
                            style={{ fontSize: "small" }}
                          >
                            {ERROR_MESSAGES}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="House No./Building No."
                          className="custom-form-control"
                          value={shipAdd?.Flat || ""}
                          onChange={(e) => {
                            setShipAdd((prev) => ({
                              ...prev,
                              Flat: e.target.value,
                            }));
                          }}
                        />
                        {error &&
                          (!shipAdd?.Flat || shipAdd?.Flat.trim() === "") && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          )}
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="Road name/Area/Colony"
                          className="custom-form-control"
                          value={shipAdd?.Colony || ""}
                          onChange={(e) => {
                            setShipAdd((prev) => ({
                              ...prev,
                              Colony: e.target.value,
                            }));
                          }}
                        />
                        {error &&
                          (!shipAdd?.Colony ||
                            shipAdd?.Colony.trim() === "") && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          )}
                      </div>

                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="Landmark"
                          className="custom-form-control"
                          value={shipAdd?.Landmark || ""}
                          onChange={(e) => {
                            setShipAdd((prev) => ({
                              ...prev,
                              Landmark: e.target.value,
                            }));
                          }}
                        />
                        {error &&
                          (!shipAdd?.Landmark ||
                            shipAdd?.Landmark.trim() === "") && (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          )}
                      </div>
                    </>
                  )}
                </div>

                {/* Right Section - Price Summary */}
                <div className="col-md-4">
                  <h5>{t("Price Details")} ({prasadList?.length} {t("Items")})</h5>
                  <div className="card p-3 shadow-sm">



                    <div className="d-flex justify-content-between">
                      <p>{t("Total Product Price")} ₹: </p>
                      <p> {Math.round(total)}</p>


                    </div>
                    <div>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            {t("Applied Wallet Amount")} (₹)

                          </p>
                          <p>
                            - {appliedCoupon?.walletAmount}
                          </p>
                        </div>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            {t("Applied Coupon Amount")} (₹)

                          </p>
                          <p>
                            - {couponAmount}
                          </p>
                        </div>
                      ) : ''}
                    </div>
                    {totalDiscountAmount !== 0 && (
                      <div className="d-flex justify-content-between">
                        <p>{t("Discount amount")} (₹):</p>
                        <p>- {totalDiscountAmount}</p>
                      </div>
                    )}
                    <hr className="flex-grow-1 my-1" />
                    <div className="d-flex justify-content-between">
                      <p>{t("Sub Total")} ₹:</p>
                      <p> {Math.round(total - totalDiscountAmount - couponAmount)}</p>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                      <p>{t("Tax")} (5 %) ₹:</p>
                      <p>+{Math.round((total - totalDiscountAmount) * 0.05)}</p>
                    </div> */}
                    <hr className="flex-grow-1 my-1" />

                    {/* <div className="d-flex justify-content-between">
                      <p>{t("Total Amount after Tax")}</p>
                      <p>
                        ₹{((total - totalDiscountAmount) * 1.05).toFixed(0) - couponAmount}
                      </p>
                    </div> */}
                    <div className="d-flex justify-content-between">
                      <p>
                        {t("Shipping Charges")} ₹:{" "}
                        <Tooltip title="Shipping Charges will calculate after selecting city.">
                          .<i class="fa-solid fa-circle-info"></i>
                        </Tooltip>
                      </p>
                      <p>+ {deliveryChargesAmt}</p>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      Total Discount
                    </p>
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      - ₹{discount}
                    </p>
                  </div> */}

                    <hr className="flex-grow-1 my-1" />
                    <div className="d-flex justify-content-between fw-bold">
                      <p>{t("Grand Total")}</p>
                      <p>₹{grandTotal}</p>
                    </div>

                    <div className='border rounded p-2 mb-2'>
                      {/* Wallet */}
                      {walletAmount !== 0 && (
                        <>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                              <i className="bi bi-wallet2 fs-5 me-2 text-primary-custom"></i>
                              <div style={{ lineHeight: "1.2" }}>
                                <strong className="small" style={{ fontWeight: "600", color: "grey" }}>{t("Use Wallet Balance")}</strong><br />
                                <small className="text-muted">{t("Available")}: ₹ {isWalletApplied ? walletAmount - appliedCoupon?.walletAmount : walletAmount}</small>
                              </div>
                            </div>
                            {isWalletApplied ? (
                              <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {

                                setIsWalletApplied(!isWalletApplied)
                              }
                              }>{t("Remove Wallet")}</button>
                            ) : (
                              <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {
                                setAppliedCoupon((PREV) => ({
                                  ...PREV, couponCode: null,
                                  isApplied: false
                                }))
                                setIsWalletApplied(!isWalletApplied)
                                setIsCouponApplied(false)
                              }
                              }>{t("Apply Wallet")}</button>
                            )}

                          </div>
                          <div className="d-flex align-items-center mb-2" style={{ fontSize: "13px" }}>
                            <hr className="flex-grow-1 my-1" />
                            <span className="px-2 text-muted">or</span>
                            <hr className="flex-grow-1 my-1" />
                          </div>
                        </>

                      )}


                      {/* Coupons */}
                      <div className="input-group input-group-sm mb-2 ">

                        {isCouponApplied ? (
                          <div

                            style={{

                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                              <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                              {appliedCoupon && (
                                <>
                                  <span
                                    style={{
                                      border: '1px dotted #333',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      backgroundColor: '#fff',
                                      color: '#333',
                                      marginLeft: '6px',
                                    }}
                                  >
                                    {appliedCoupon?.couponCode}
                                  </span>

                                </>


                              )}
                            </div>
                            <span
                              onClick={() => {
                                setAppliedCoupon((prev) => ({
                                  ...prev, couponCode: null,
                                  isApplied: false,
                                  couponAmount: 0,
                                  walletAmount: 0
                                }))
                                setIsCouponApplied(false)
                              }}
                              style={{
                                // border: '1px dotted #333',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                backgroundColor: '#fff',
                                color: '#a52444',
                                marginLeft: '6px',
                              }} >



                              {t("Remove")}

                            </span>
                            <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                          </div>
                        ) : (
                          <div className='border border-1'
                            onClick={() => handleOpenCoupenModal()}
                            style={{

                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              // fontWeight: 'bold',
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{
                                backgroundColor: '#a52444',
                                color: 'white',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                marginRight: '10px',

                              }}>
                                %
                              </div>
                              <span style={{ fontWeight: '400' }}>{t("View Coupons & Offers")}</span>

                            </div>
                            {/* <span style={{ fontSize: '20px', fontWeight: 'bolder' }}>›</span> */}
                          </div>
                        )}

                      </div>
                      {/* <hr className="flex-grow-1 my-1" className="flex-grow-1 my-3" /> */}
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 mt-2 mb-3">
                    <button
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      className="Normal-app-btn"
                      onClick={() => setShowProductDetails(!showProductDetails)}
                    >
                      {showProductDetails
                        ? allFieldsFilled
                          ? t("Edit Address")
                          : t("Enter Address")
                        : t("View Products")}
                    </button>

                    {shipAdd.City &&
                      shipAdd.Flat &&
                      shipAdd.Colony &&
                      shipAdd.Landmark &&
                      shipAdd.PinCode &&
                      shipAdd.State &&
                      deliveryChargesAmt && (
                        <>
                          <button
                            style={{ padding: "5px 16px", fontSize: "14px" }}
                            className="Normal-app-btn"
                            onClick={() => PaymentApproved("online")}
                          >
                            {t("Pay")}
                          </button>
                          {/* <button
                            style={{ background: "#8f3246" }}
                            className="btn text-white"
                            onClick={() => handlePhonePayPayment("online")}
                          >
                            Phone Pay
                          </button> */}
                        </>
                      )}
                  </div>
                  {/* <div className="mt-3 text-center">
                    <p className="mt-2">Your Safety, Our Priority</p>
                    <p className="text-muted small">
                      We make sure that your package is safe at every point of
                      contact.
                    </p>
                  </div> */}
                </div>
              </div>
            </>
          )}
        </div>
        {showCodModal && (
          <CODPaymentModal
            show={showCodModal}
            onHide={() => setShowCodModal(false)}
            modelRequestData={modelRequestData}
            btnClick={() => PaymentApproved("cash")}
            setModelRequestData={setModelRequestData}
          />
        )}
      </>
    );
  };
  const ProductCart = () => {
    return (
      <>
        <div className="container mt-4">
          {product?.length > 0 && (
            <>
              <div
                className="row w-100 mt-3"
                style={{ "--bs-gutter-x": "6px" }}
              >
                {/* Left Section - Cart Items */}
                <div className="col-md-8 ">
                  {showProductDetails ? (
                    // Product Details UI
                    <>
                      <h5>{t("Product Details")}</h5>
                      {product?.map((item) => (
                        <div
                          key={item.id}
                          className="card mb-3 p-3 shadow-sm position-relative"
                        >
                          {/* Remove button */}
                          <button
                            className="btn btn-sm btn-outline-secondary position-absolute"
                            style={{ top: "10px", right: "10px" }}
                            onClick={() => deleteProduct(item)}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>

                          <div className="row g-3 align-items-center">
                            {/* Product Image */}
                            <div className="col-3">
                              <img
                                src={item.productImageURL || placeholderImg}
                                alt={item.productName}
                                className="img-fluid rounded"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = placeholderImg;
                                }}
                                style={{
                                  width: "80%",
                                  height: "auto",
                                  objectFit: "cover",
                                }}
                              />
                            </div>

                            {/* Product Details */}
                            <div className="col-9">
                              <h5 className="mb-1">{item.productName}</h5>
                              <h6 style={{ color: "#A42642" }}>
                                ₹{" "}
                                {Math.round(item.discountedAmount)}
                                {Number(item.discount) !== 0 && (
                                  <>
                                    <span
                                      className="text-muted ms-2"
                                      style={{
                                        textDecoration: "line-through",
                                        fontSize: "14px",
                                      }}
                                    >
                                      ₹ {item.productPrice}
                                    </span>
                                    <p>
                                      <span
                                        style={{ background: "#8f3246" }}
                                        className="badge"
                                      >
                                        {t("Discount")} {item.discount}%
                                      </span>
                                    </p>
                                  </>
                                )}
                              </h6>

                              {/* Quantity Controls */}
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => removeQuantity(item)}
                                >
                                  -
                                </button>
                                <span>{item.quantity}</span>
                                <button
                                  className="btn btn-sm btn-outline-custom"
                                  onClick={() => AddQuantity(item)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    // Address Input UI
                    <>
                      <h5>{t("Address Details")}</h5>
                      <div style={{ width: "95%" }}>
                        <div class="mb-3 ">
                          <Select
                            styles={customSelectStyles}
                            name="Country"
                            placeholder={t("Select Country")}
                            options={countryList}
                            value={
                              countryList.find(
                                (country) =>
                                  country.value === shipAdd?.countryID
                              ) || null
                            } // Ensure correct list
                            onChange={(e) => {
                              const selectedCountry = countryList.find(
                                (country) => country.value === e.value
                              );

                              if (selectedCountry) {
                                setShipAdd((prev) => ({
                                  ...prev,
                                  Country: selectedCountry.label, // Store Country Name
                                  countryID: selectedCountry.value, // Store Country ID
                                }));
                              }

                              setSelectedCountry(e.value);
                              setStateList([]); // Reset state when country changes
                              setCityList([]); // Reset city when country changes
                              fetchStateList(e.value); // Fetch new state list based on country
                            }}
                          />
                        </div>
                        <div class="mb-3 ">
                          <Select
                            styles={customSelectStyles}
                            name="State"
                            placeholder={t("Select State")}
                            options={stateList}
                            value={
                              stateList.find(
                                (state) => state.value === shipAdd?.stateID
                              ) || null
                            }
                            onChange={(e) => {
                              setSelectedState(e.value);
                              const selectedState = stateList.find(
                                (state) => state.value === e.value
                              );

                              if (selectedState) {
                                setShipAdd((prev) => ({
                                  ...prev,
                                  State: selectedState.label,
                                  stateID: selectedState.value, // Store StateID
                                }));
                              }
                            }}
                          />
                        </div>
                        <div class="mb-3 ">
                          <Select
                            styles={customSelectStyles}
                            name="City"
                            placeholder={t("Select City")}
                            options={cityList}
                            value={
                              cityList.find(
                                (city) => city.value === shipAdd?.districtID
                              ) || null
                            } // Fix here
                            onChange={(e) => {
                              const selectedCity = cityList.find(
                                (city) => city.value === e.value
                              );

                              if (selectedCity) {
                                setShipAdd((prev) => ({
                                  ...prev,
                                  City: selectedCity.label,
                                  districtID: selectedCity.value, // Store DistrictID
                                }));
                              }
                            }}
                          />
                        </div>

                        <div class="mb-3 ">
                          <input
                            type="text"
                            placeholder={t("Pincode")}
                            className="custom-form-control"
                            id="pincode"
                            value={shipAdd?.PinCode || ""}
                            maxLength={6}
                            onChange={(e) => {
                              // Remove non-alphabet characters except spaces
                              const formattedInput = e.target.value
                                .replace(/[^\d]/g, "")
                                .trim();

                              setShipAdd((prev) => ({
                                ...prev,
                                PinCode: formattedInput, // Update Flat instead of name
                              }));
                            }}
                          />
                          {error &&
                            (shipAdd?.PinCode === "" ||
                              shipAdd?.PinCode === null ||
                              shipAdd?.PinCode === undefined) ? (
                            <span
                              className="text-danger"
                              style={{ fontSize: "small" }}
                            >
                              {ERROR_MESSAGES}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder={t("House No./Building No.")}
                            className="custom-form-control"
                            value={shipAdd?.Flat || ""}
                            onChange={(e) => {
                              setShipAdd((prev) => ({
                                ...prev,
                                Flat: e.target.value,
                              }));
                            }}
                          />
                          {error &&
                            (!shipAdd?.Flat || shipAdd?.Flat.trim() === "") && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "small" }}
                              >
                                {ERROR_MESSAGES}
                              </span>
                            )}
                        </div>

                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder={t("Road name/Area/Colony")}
                            className="custom-form-control"
                            value={shipAdd?.Colony || ""}
                            onChange={(e) => {
                              setShipAdd((prev) => ({
                                ...prev,
                                Colony: e.target.value,
                              }));
                            }}
                          />
                          {error &&
                            (!shipAdd?.Colony ||
                              shipAdd?.Colony.trim() === "") && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "small" }}
                              >
                                {ERROR_MESSAGES}
                              </span>
                            )}
                        </div>

                        <div className="mb-3">
                          <input
                            type="text"
                            placeholder={t("Landmark")}
                            className="custom-form-control"
                            value={shipAdd?.Landmark || ""}
                            onChange={(e) => {
                              setShipAdd((prev) => ({
                                ...prev,
                                Landmark: e.target.value,
                              }));
                            }}
                          />
                          {error &&
                            (!shipAdd?.Landmark ||
                              shipAdd?.Landmark.trim() === "") && (
                              <span
                                className="text-danger"
                                style={{ fontSize: "small" }}
                              >
                                {ERROR_MESSAGES}
                              </span>
                            )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Right Section - Price Summary */}
                <div className="col-md-4">
                  <h5>{t("Price Details")} ({product?.length} {t("Items")})</h5>
                  <div className="card p-3 shadow-sm">



                    <div className="d-flex justify-content-between">
                      <p>{t("Total Product Price")} ₹: </p>
                      <p> {Math.round(total)}</p>


                    </div>
                    <div>
                      {isWalletApplied && appliedCoupon?.isApplied === false ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            {t("Applied Wallet Amount")} (₹)

                          </p>
                          <p>
                            - {appliedCoupon?.walletAmount}
                          </p>
                        </div>
                      ) : isWalletApplied === false && appliedCoupon?.isApplied ? (
                        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
                          <p>
                            {t("Applied Coupon Amount")} (₹)

                          </p>
                          <p>
                            - {couponAmount}
                          </p>
                        </div>
                      ) : ''}
                    </div>
                    {totalDiscountAmount !== 0 && (
                      <div className="d-flex justify-content-between">
                        <p>{t("Discount amount")} (₹):</p>
                        <p>- {totalDiscountAmount}</p>
                      </div>
                    )}
                    <hr className="flex-grow-1 my-1" />
                    <div className="d-flex justify-content-between">
                      <p>{t("Sub Total")} ₹:</p>
                      <p> {Math.round(total - totalDiscountAmount - couponAmount)}</p>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                      <p>{t("Tax")} (5 %) ₹:</p>
                      <p>+{Math.round((total - totalDiscountAmount) * 0.05)}</p>
                    </div> */}
                    <hr className="flex-grow-1 my-1" />

                    {/* <div className="d-flex justify-content-between">
                      <p>{t("Total Amount after Tax")}</p>
                      <p>
                        ₹{((total - totalDiscountAmount) * 1.05).toFixed(0) - couponAmount}
                      </p>
                    </div> */}
                    <div className="d-flex justify-content-between">
                      <p>
                        {t("Shipping Charges")} ₹:{" "}
                        <Tooltip title="Shipping Charges will calculate after selecting city.">
                          .<i class="fa-solid fa-circle-info"></i>
                        </Tooltip>
                      </p>
                      <p>+ {deliveryChargesAmt}</p>
                    </div>
                    {/* <div className="d-flex justify-content-between">
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      Total Discount
                    </p>
                    <p style={{ color: "#8f3246", fontWeight: "bold" }}>
                      - ₹{discount}
                    </p>
                  </div> */}

                    <hr className="flex-grow-1 my-1" />
                    <div className="d-flex justify-content-between fw-bold">
                      <p>{t("Grand Total")}</p>
                      <p>₹{grandTotal}</p>
                    </div>
                    <div className='border rounded p-2 mb-2'>
                      {/* Wallet */}
                      {walletAmount !== 0 && (
                        <>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <div className="d-flex align-items-center">
                              <i className="bi bi-wallet2 fs-5 me-2 text-primary-custom"></i>
                              <div style={{ lineHeight: "1.2" }}>
                                <strong className="small" style={{ fontWeight: "600", color: "grey" }}>{t("Use Wallet Balance")}</strong><br />
                                <small className="text-muted">{t("Available")}: ₹ {isWalletApplied ? walletAmount - appliedCoupon?.walletAmount : walletAmount}</small>
                              </div>
                            </div>
                            {isWalletApplied ? (
                              <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {

                                setIsWalletApplied(!isWalletApplied)
                              }
                              }>{t("Remove Wallet")}</button>
                            ) : (
                              <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {
                                setAppliedCoupon((PREV) => ({
                                  ...PREV, couponCode: null,
                                  isApplied: false
                                }))
                                setIsWalletApplied(!isWalletApplied)
                                setIsCouponApplied(false)
                              }
                              }>{t("Apply Wallet")}</button>
                            )}

                          </div>
                          <div className="d-flex align-items-center mb-2" style={{ fontSize: "13px" }}>
                            <hr className="flex-grow-1 my-1" />
                            <span className="px-2 text-muted">or</span>
                            <hr className="flex-grow-1 my-1" />
                          </div>
                        </>

                      )}


                      {/* Coupons */}
                      {isCouponApplied ? (
                        <div

                          style={{

                            borderRadius: '10px',
                            padding: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',

                            color: '#000',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            width: '100%'
                          }}
                        >
                          <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                            <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                            {appliedCoupon && (
                              <>
                                <span
                                  style={{
                                    border: '1px dotted #333',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    backgroundColor: '#fff',
                                    color: '#333',
                                    marginLeft: '6px',
                                  }}
                                >
                                  {appliedCoupon?.couponCode}
                                </span>

                              </>


                            )}
                          </div>
                          <span
                            onClick={() => {
                              setAppliedCoupon((prev) => ({
                                ...prev, couponCode: null,
                                isApplied: false,
                                couponAmount: 0,
                                walletAmount: 0
                              }))
                              setIsCouponApplied(false)
                              setCouponCodeInput("")
                            }}
                            style={{

                              padding: '2px 6px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              backgroundColor: '#fff',
                              color: '#a52444',
                              marginLeft: '6px',
                            }} >



                            {t("Remove")}

                          </span>
                          <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                        </div>
                      ) : (
                        <div className="mb-2">
                          {/* Input + Apply */}
                          <div className="d-flex gap-2">
                            <input
                              type="text"
                              className="custom-form-control"
                              placeholder={t("Enter Coupon Code")}
                              value={couponCodeInput}
                              onChange={(e) => {
                                setCouponCodeInput(e.target.value);
                                if (couponMessageVisible) {
                                  setCouponMessage("");
                                  setCouponMessageVisible(false);
                                }
                              }}
                            />

                            <button
                              type="button"
                              style={{ padding: "5px 16px", fontSize: "14px" }}
                              className="Normal-app-btn"
                              disabled={!couponCodeInput.trim() || isApplying}
                              onClick={async () => {
                                setCouponMessage("");
                                setCouponMessageVisible(false);

                                const result = await applyCoupon(couponCodeInput);

                                if (result.success) {
                                  setCouponMessage("");
                                  setCouponMessageVisible(false);
                                } else {
                                  setCouponMessage(result.message);
                                  setCouponMessageVisible(true);
                                }
                              }}
                            >
                              {isApplying ? t("Applying...") : t("Apply")}
                            </button>
                          </div>

                          {/* Coupon validation message */}
                          {couponMessageVisible && couponMessage && (
                            <div
                              style={{
                                color: "#dc3545",
                                fontSize: "12px",
                                marginTop: "5px",
                                paddingLeft: "2px",
                              }}
                            >
                              {couponMessage}
                            </div>
                          )}
                        </div>
                      )}
                      {/* <div className="input-group input-group-sm mb-2 ">

                        {isCouponApplied ? (
                          <div

                            style={{

                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                              <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                              {appliedCoupon && (
                                <>
                                  <span
                                    style={{
                                      border: '1px dotted #333',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      backgroundColor: '#fff',
                                      color: '#333',
                                      marginLeft: '6px',
                                    }}
                                  >
                                    {appliedCoupon?.couponCode}
                                  </span>

                                </>


                              )}
                            </div>
                            <span
                              onClick={() => {
                                setAppliedCoupon((prev) => ({
                                  ...prev, couponCode: null,
                                  isApplied: false,
                                  couponAmount: 0,
                                  walletAmount: 0
                                }))
                                setIsCouponApplied(false)
                              }}
                              style={{
                                
                                padding: '2px 6px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                backgroundColor: '#fff',
                                color: '#a52444',
                                marginLeft: '6px',
                              }} >



                              {t("Remove")}

                            </span>
                            <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                          </div>
                        ) : (
                          <div className='border border-1'
                            onClick={() => handleOpenCoupenModal()}
                            style={{

                              borderRadius: '10px',
                              padding: '10px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              cursor: 'pointer',
                              
                              color: '#000',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                              width: '100%'
                            }}
                          >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{
                                backgroundColor: '#a52444',
                                color: 'white',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                marginRight: '10px',

                              }}>
                                %
                              </div>
                              <span style={{ fontWeight: '400' }}>{t("View Coupons & Offers")}</span>

                            </div>
                          </div>
                        )}

                      </div> */}
                    </div>
                  </div>
                  <div className="d-flex align-items-start gap-2 mt-2 mb-3">
                    <button
                      style={{ padding: "5px 16px", fontSize: "14px" }}
                      className="Normal-app-btn"
                      onClick={() => setShowProductDetails(!showProductDetails)}
                    >
                      {showProductDetails
                        ? allFieldsFilled
                          ? (t("Edit Address"))
                          : t("Enter Address")
                        : t("View Products")}
                    </button>

                    {shipAdd.City &&
                      shipAdd.Flat &&
                      shipAdd.Colony &&
                      shipAdd.Landmark &&
                      shipAdd.PinCode &&
                      shipAdd.State &&
                      deliveryChargesAmt && (
                        <>
                          <button
                            style={{ padding: "5px 16px", fontSize: "14px" }}
                            className="Normal-app-btn"
                            onClick={() => PaymentApproved("online")}
                          >
                            {t("Pay")}
                          </button>
                          {/* <button
                            style={{ background: "#8f3246" }}
                            className="btn text-white"
                            onClick={() => handlePhonePayPayment("online")}
                          >
                            Phone Pay
                          </button> */}
                        </>
                      )}
                  </div>
                  {/* <div className="mt-3 text-center">
                    <p className="mt-2">Your Safety, Our Priority</p>
                    <p className="text-muted small">
                      We make sure that your package is safe at every point of
                      contact.
                    </p>
                  </div> */}
                </div>
              </div>
            </>
          )}
        </div>
        {showCodModal && (
          <CODPaymentModal
            show={showCodModal}
            onHide={() => setShowCodModal(false)}
            modelRequestData={modelRequestData}
            btnClick={() => PaymentApproved("cash")}
            setModelRequestData={setModelRequestData}
          />
        )}

      </>
    );
  };

  return (
    <>
      {/* {isPrasadCart && PrasadCart()}
      {isProductCart && ProductCart()} */}
      {(isProductCart && isPrasadCart) ? (
        <>
          <div className="container mt-4">
            {product?.length > 0 ? (
              <Tab.Container
                defaultActiveKey={showProductTabDetails ? "products" : "Prasad"}
              >
                <div className="row w-100">
                  {/* Left Section - Tabs and Content */}
                  <div className="col-md-12">
                    <Nav variant="tabs" defaultActiveKey="products">
                      <Nav.Item>
                        <Nav.Link
                          eventKey="products"
                          onClick={() => {
                            setShowProductTabDetails(true);
                            setShowProductDetails(true);
                            setIsTabChange(false);
                          }}
                          style={{ color: isTabChange ? "#a52444" : "black" }}
                        >
                          {t("Products")}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="prasad"
                          onClick={() => {
                            setShowProductTabDetails(false);
                            setShowProductDetails(true);
                            setIsTabChange(true);
                          }}
                          style={{ color: "#a52444" }}
                        >
                          {t("Prasad")}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content className="mt-3">
                      {/* Product Tab */}

                      <Tab.Pane eventKey="products">{ProductCart()}</Tab.Pane>

                      {/* Prasad Tab */}

                      <Tab.Pane eventKey="prasad">{PrasadCart()}</Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            ) : (
              <div className="d-flex justify-content-center align-items-center vh-10 w-100" style={{ marginBottom: '22px' }}>
                <div className="text-center">
                  <img
                    src={fav}
                    alt="Empty Cart"
                    className="img-fluid mb-3"
                    width={100}
                    height={100}
                    style={{ maxWidth: "400px" }}
                  />
                  <h5 className="fw-bold">{t("Your cart is empty")}</h5>
                  <p className="text-muted">
                    {t("Just relax, let us help you find some first-class products")}
                  </p>
                  <Link to="/my-store">
                    <button
                      style={{ padding: '5px 16px', fontSize: '14px' }}
                      className=" Normal-app-btn "
                    >
                      {t("Add More Products")}{" "}
                      <i className="fa fa-shopping-cart ms-1"></i>
                    </button>
                  </Link>
                </div>
              </div>
            )}
          </div>
          {showCodModal && (
            <CODPaymentModal
              show={showCodModal}
              onHide={() => setShowCodModal(false)}
              modelRequestData={modelRequestData}
              btnClick={() => PaymentApproved("cash")}
              setModelRequestData={setModelRequestData}
            />
          )}
        </>
      ) : isPrasadCart && !isProductCart ? (
        PrasadCart()
      ) : (
        ProductCart()
      )}



      {(productTotalRecords <= 0) && (
        <div className="mt-3">

          <NoResultFoundModel moduleName="cart" totalRecords={productTotalRecords} />
        </div>
      )}

      <CouponModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        modelRequestData={modelRequestData}
        setAppliedCoupon={setAppliedCoupon}
        setIsWalletApplied={setIsWalletApplied}
        setIsCouponApplied={setIsCouponApplied}
        apiParam={couponObj} />
    </>
  );
};

export default ViewCart;
